import { Row, Spin } from 'antd';
import { ModalTheme } from '../../../components/modal';
import { TextLarge } from '../../../components/text';
import { ButtonTheme } from '../../../components/buttons';
import { RenderForm } from '../../../components/forms';
import { useForm } from 'react-hook-form';
import React from 'react';
import { shippingSelfQuery } from '../../../services/react-query/optionMasterQuery';
import { ContainerButton } from '../../../styles/global-style';
import { useDownloadTemplate } from '../hooks/useDownloadTemplate';
import { useUpdateExcel } from '../hooks/useUpdateExcel';
import { UpdateExcel } from '../../../resources/payload';
import { FORM_UPLOAD_FILE } from '../form';

export const UploadExcelModal = ({ open, onToggle }) => {
  const { control, setValue, getValues, handleSubmit } = useForm();
  const { data: shippingSelfOptions } = shippingSelfQuery();
  const { mutate: onDownloadTem, loading: isLoaddingDowndloadTem } = useDownloadTemplate();
  const { mutate: onUpdateExcel, loading: isLoadingUpdateExcel } = useUpdateExcel();

  const onSubmit = () =>
    handleSubmit((values) => {
      const formData = UpdateExcel(values);
      onUpdateExcel(formData, {
        onSuccess: () => {
          onToggle({ defaultValue: '' });
        },
      });
    })();

  return (
    <Spin spinning={isLoaddingDowndloadTem || isLoadingUpdateExcel}>
      <ModalTheme title=" " open={open} onToggle={onToggle}>
        <Row justify="center">
          <TextLarge text="นำเข้าเลขพัสดุ" />
        </Row>
        <Row justify="end">
          <ButtonTheme useFor="DOWNLOADTEM" onClick={() => onDownloadTem()} />
        </Row>
        <RenderForm
          control={control}
          getValues={getValues}
          setValue={setValue}
          forms={FORM_UPLOAD_FILE({ shippingSelfOptions })}
        />
        <div style={{ marginTop: '30px' }}>
          <ContainerButton center>
            <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
            <ButtonTheme useFor="CANCEL" onClick={onToggle} />
          </ContainerButton>
        </div>
      </ModalTheme>
    </Spin>
  );
};
